import React from "react";

type ReportButtonProps = {
  unseenCount: number;
  isOpen: boolean;
  onClick: () => void;
  compact?: boolean;
};

export function ReportButton({ unseenCount, isOpen, onClick, compact = false }: ReportButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={unseenCount > 0 ? `報告 ${unseenCount}件の新着` : "報告"}
      aria-expanded={isOpen}
      className={`relative inline-flex min-h-11 items-center justify-center rounded-full border border-[#EADBC8] bg-white/80 text-sm font-black text-[#7C5A4E] shadow-sm ${compact ? "px-3" : "px-4"}`}
    >
      報告
      {unseenCount > 0 ? (
        <span className="ml-2 inline-flex min-w-5 items-center justify-center rounded-full bg-[#B65A4D] px-1.5 py-0.5 text-[10px] font-black text-white">
          {unseenCount}
        </span>
      ) : null}
    </button>
  );
}
